window.oxgMainMenuOpen = null
window.oxgBodyScrollPosY = null

let debounceTimeout = null
let debounceDelay = 100

function create() {
  let btn = document.getElementById('oxg-main-menu-toggle')
  if(!btn) return
  window.oxgMainMenuOpen = false
  btn.addEventListener('click', (e)=> {
    e.preventDefault()
    window.oxgMainMenuOpen ? closeMainMenu() : openMainMenu()
  })
}

function openMainMenu() {
  window.oxgMainMenuOpen = true
  let container = document.getElementById('oxg-flyout-container')
  let bg = document.getElementById('oxg-flyout-bg')
  let wrap = document.getElementById('oxg-flyout-wrap')
  if (!container || !bg || !wrap) return
  container.setAttribute('aria-modal', 'true')
  container.setAttribute('role', 'menu')
  container.setAttribute('aria-hidden', 'false')

  //Clone Menu and Destroy old (makes fresh event listeners possible)
  let menu = container.querySelector('.flyout-interactive-elements-warp')
  let menuParent = menu ? menu.parentNode : null
  let menuClone = menu ? menu.cloneNode(true) : null
  if(menuParent && menuClone) {
    menu.remove()
    menuParent.appendChild(menuClone)
  }

  //focus close button or first element
  let firstLink
  let closeLink = container.querySelector('.close-flyout-link')
  if(closeLink) {
    closeLink.focus()
    closeLink.addEventListener('click', (e)=> {
      e.preventDefault()
      closeMainMenu()
    })
  } else {
    firstLink = container.querySelector('a')
    if(firstLink) {
      firstLink.focus()
    }
  }

  //create focus loop between first and last link element
  let lastLink = container.querySelector('a.is-last')
  if((lastLink && closeLink) || (lastLink && firstLink)) {
    let first = closeLink ? closeLink : firstLink
    lastLink.addEventListener('keydown', (e)=> {
      console.log('last', e)
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault()
        clearTimeout(debounceDelay)
        debounceDelay = setTimeout(()=> {
          console.log('focusing first link', first)
          first.focus()
        }, debounceDelay)
      }
    })
    first.addEventListener('keydown', (e)=> {
      console.log('first', e)
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault()
        clearTimeout(debounceDelay)
        debounceDelay = setTimeout(()=> {
          console.log('focusing last link', lastLink)
          lastLink.focus()
        }, debounceDelay)
      }
    })
  }

  //Show bg and add close functionality
  let bgClone = bg.cloneNode(true)
  bgClone.style.pointerEvents = 'all'
  bg.remove()
  container.prepend(bgClone)
  bgClone.addEventListener('click', ()=> {
    closeMainMenu()
  })
  setTimeout(function() {bgClone.style.opacity = '1'}, 1);

  //slide in 
  wrap.style.transform = 'translateX(0)'

  //freeze body
  let body = document.body
  body.classList.add('main-menu-open')
  window.oxgBodyScrollPosY = window.oxg.page.scrollY
  body.style.overflowY = 'hidden'
  body.style.marginTop = '-' + scrollY
}

function closeMainMenu() {
  //reset focus
  let toggle, firstLink
  toggle = document.getElementById('oxg-main-menu-toggle')
  console.log(toggle)
  if (toggle) {
    toggle.focus()
  } else {
    firstLink = document.body.querySelector('a')
    firstLink.focus()
  }
  window.oxgMainMenuOpen = false
  let container = document.getElementById('oxg-flyout-container')
  let bg = document.getElementById('oxg-flyout-bg')
  let wrap = document.getElementById('oxg-flyout-wrap')
  container.setAttribute('aria-hidden', 'true')
  container.removeAttribute('aria-modal')
  container.setAttribute('role', 'menu')
  if (!container || !bg || !wrap) return
  bg.style.opacity = '0'
  bg.style.pointerEvents = 'none'
  wrap.style.transform = 'translateX(100%)' 
  let body = document.body
  body.classList.remove('main-menu-open')
  body.style.overflowY = 'scroll'
  body.style.marginTop = '0'
  body.scroll(0, window.oxgBodyScrollPosY)

}

document.addEventListener('DOMContentLoaded', () => { 
  create();
});

document.addEventListener('focusin', function(event) {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
    debounceTimeout = null;
  }
}, true);